
import OlMap from 'ol/Map';
import OlView from 'ol/View';
import {TileWMS, Vector as VectorSource, Cluster, XYZ, OSM} from 'ol/source';
import {Tile as TileLayer, Vector as VectorLayer, Group as LayerGroup, Heatmap as HeatmapLayer} from 'ol/layer';
import OlProj from 'ol/proj/Projection';
import OlFormatGeoJSON from 'ol/format/GeoJSON';
import {format} from 'ol/coordinate';
import WMTS from 'ol/source/WMTS';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import proj4 from 'proj4';
import { get as getProjection, fromLonLat } from 'ol/proj';
import { register } from 'ol/proj/proj4.js';
import {getWidth, getTopLeft} from 'ol/extent';
import {authenticationService} from '../services';

import {Circle as CircleStyle, Fill, Stroke, Style, Text, Icon} from 'ol/style';
import { config } from "../config";
import 'moment/locale/hr';
import niski_resetkasti from '../images/icons/green_marker/niski_resetkasti.png'
import niski_spiralni from '../images/icons/green_marker/niski_spiralni.png'
import obrnuti_u from '../images/icons/green_marker/obrnuti_u_v6.png'
import skloniste from '../images/icons/green_marker/skloniste.png'
import parkirna_konstrukcija from '../images/icons/green_marker/parkirna_konstrukcija.png'
import punionica_za_e from '../images/icons/green_marker/e_punionica.png'
import stupicasti from '../images/icons/green_marker/stupicasti_stalak.png'
import utor from '../images/icons/green_marker/utor_za_kotac.png'
import visoki_resetkasti from '../images/icons/green_marker/visoki_resetkasti.png'
import visoki_spiralni from '../images/icons/green_marker/visoki_spiralni.png'
import zidni from '../images/icons/green_marker/zidni_nosac.png'
import valoviti from '../images/icons/green_marker/valoviti_stalak.png'
import stalak_za from '../images/icons/green_marker/stalak_za_romobile.png'
import ostali_tipovi from '../images/icons/green_marker/ostali_tipovi.png'

import romobil_potraznja from '../images/icons/romobil_potraznja.png'
import bicikl_potraznja from '../images/icons/bicikl_potraznja.png'

proj4.defs('EPSG:3765', "+proj=tmerc +lat_0=0 +lon_0=16.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
register(proj4);
const htrs = getProjection('EPSG:3765');
htrs.setExtent([247020.52671340841, 4688936.3515996207, 741441.98263387219, 5183357.8075200841]);

const htrs_extent = htrs.getExtent(),
    size = getWidth(htrs_extent) / 256,
    resolutions = new Array(15),
    matrixIds = new Array(15);
for (let i = 0; i < 15; i++) {
	resolutions[i] = size / Math.pow(2, i); 
	matrixIds[i] = "EPSG:3765:" + i;
}
const htrs_tilegrid = new WMTSTileGrid({
    origin: getTopLeft(htrs_extent),
    extent: htrs_extent,
    resolutions: resolutions,
    matrixIds: matrixIds
});

export function HtrsExtents(){
	return htrs.getExtent();
}

let symbolMap = new Map();
symbolMap.set('obrnuti_U', [obrnuti_u, 0.07])
.set('niski_resetkasti', [niski_resetkasti, 0.07])
.set('visoki_resetkasti', [visoki_resetkasti, 0.07])
.set('niski_spiralni', [niski_spiralni, 0.07])
.set('visoki_spiralni', [visoki_spiralni, 0.07])
.set('valoviti_stalak', [valoviti, 0.07])
.set('stupcasti_stalak', [stupicasti, 0.07])
.set('zidni_nosac', [zidni, 0.07])
.set('utor_za', [utor, 0.07])
.set('ormar_za', [skloniste, 0.07])
.set('parkirna_konstrukcija', [parkirna_konstrukcija, 0.07])
.set('punionica_za', [punionica_za_e, 0.07])
.set('stalak_za',[stalak_za,0.07])
.set('romobil', [romobil_potraznja, 0.07])
.set('bicikl', [bicikl_potraznja, 0.07])
.set('other', [bicikl_potraznja, 0.00])
.set('ostali_tip', [ostali_tipovi, 0.07])
.set('romobil - Alternativna potražnja (zbog neadekvatnosti ili nepostojanja stalka na lokaciji), primjer bicikl: bicikl pričvršćen za drvo, znak, ogradu..', [romobil_potraznja, 0.07])
.set('romobil - Potražnja za postojećim stalkom na lokaciji', [romobil_potraznja, 0.07])
.set('bicikl - Alternativna potražnja (zbog neadekvatnosti ili nepostojanja stalka na lokaciji), primjer bicikl: bicikl pričvršćen za drvo, znak, ogradu..', [bicikl_potraznja, 0.07])
.set('bicikl - Potražnja za postojećim stalkom na lokaciji', [bicikl_potraznja, 0.07])


const styleCache = {};
const switchResolution = 100;

export function createPointLayer(sourceLayerName, layerName, icon, attribute,noMinimalZoom,filterType){	
	function styleFunction(feature) {
		let symbol = icon;
		let key = layerName;
		if (attribute){
			if (symbolMap.has(feature.values_[attribute])){
				symbol = symbolMap.get(feature.values_[attribute]);
				key = feature.values_[attribute];
			}
		}
		feature.set('symbolDefinition', symbol);
		
		let style = styleCache[key];
		if (!style) {
			style = new Style({
				image: new Icon({
					crossOrigin: 'anonymous',
					src:symbol[0],
					scale: symbol[1],
					anchor: [0.5, 1],
          			anchorXUnits: 'fraction',
          			anchorYUnits: 'fraction',
				}),
			});
			styleCache[key] = style;
		}
		return style;		
    }
	let pointlayer
    if(filterType){
		 pointlayer = new VectorLayer({
			name: layerName,
			visible: true,		
			source: new VectorSource({			
				url: `${config.geoserverUrl}/ows?service=WFS&version=1.0.0&request=GetFeature&`+
					'typename=' + sourceLayerName + '&outputFormat=application/json'+ `&CQL_FILTER=((token='${authenticationService.getUser()?.accessToken}'or(verified=1))` + `and(type='${filterType}'))`,
				format: new OlFormatGeoJSON()
			}),
			style: new Style({image: new CircleStyle({})}),
			//maxResolution:250,
			zIndex: 30
		});
	}
	else{
		 pointlayer = new VectorLayer({
			name: layerName,
			visible: true,		
			source: new VectorSource({			
				url: `${config.geoserverUrl}/ows?service=WFS&version=1.0.0&request=GetFeature&`+
					'typename=' + sourceLayerName + '&outputFormat=application/json'+ `&CQL_FILTER=(token='${authenticationService.getUser()?.accessToken}'or(verified=1))`,
				format: new OlFormatGeoJSON()
			}),
			style: new Style({image: new CircleStyle({})}),
			//maxResolution:250,
			zIndex: 30
		});
	}

	
	if(!noMinimalZoom){
	function hide(event){
		pointlayer.setMaxResolution(switchResolution);
		pointlayer.setStyle(styleFunction);
		pointlayer.un('prerender', hide);
	}
	pointlayer.on('prerender', hide);
	}
	else{
		function hide(event){
			pointlayer.setMaxResolution(3000);
			pointlayer.setStyle(styleFunction);
			pointlayer.un('prerender', hide);
		}
		pointlayer.on('prerender', hide);

	}
	return pointlayer;
}

export function createClusterLayer(sourceLayerName, layerName){	
	function styleFunction(feature, resolution) {
		
		const {ponuda, potraznja} = feature.get('features').reduce((sums, cur) => {
			sums.ponuda += cur.get('ponuda');
			sums.potraznja += cur.get('potraznja');
			return sums;
		},{ponuda:0, potraznja:0});
		
		const ringColor = (ponuda>potraznja) ? 'green' : (potraznja>ponuda) ? 'red': 'DimGray';

		function textStyle(textBaseline, text, color){
			return new Style({
				text: new Text({
					text: text + '',
					textAlign: 'center',
					textBaseline: textBaseline,
					scale: 1,
					font: 'normal 15px Arial',
					fill: new Fill({color: 'white'}),
					stroke: new Stroke({
						color: color,
						width: 2
					})
				})			
			})
		}
		
		return [
			new Style({
				image: new CircleStyle({
					radius: 20,
					stroke: new Stroke({
						color: ringColor,
						width: 2
					}),
					fill: new Fill({
						color: 'rgba(250, 250, 250, 0.6)'
					})
				})
			}),
			textStyle('top', ponuda, 'green'),
			textStyle('bottom', potraznja, 'red')
		];
    }
	
	var clusterlayer = new VectorLayer({
		name: layerName,
		//maxZoom: 12,
		minResolution:switchResolution,
		source: new Cluster({ 
			distance: 40,
			source: new VectorSource({
				url: `${config.geoserverUrl}/ows?service=WFS&version=1.0.0&request=GetFeature&`+
					`typename=${sourceLayerName}&outputFormat=application/json`,
				format: new OlFormatGeoJSON()
			})
		}),
		style: styleFunction,
		zIndex: 30
	});
    
	return clusterlayer;
}

export function createWMSLayer(Name, LayerName, visible){
	const myWMSLayer = new TileLayer({
		name: Name,
		visible: visible,
		//combine: true,
		source: new TileWMS({
			url: `${config.geoserverUrl}/ciklopark/wms`,
			params: {'LAYERS': LayerName}
		})
	});
	return myWMSLayer;
}

export function createCascadedDguWmsLayer(Name, LayerName, visible){	
	const myWMSLayer = new TileLayer({
		name: Name,
		//className:Name,
		visible: visible,
		source: new TileWMS({
			url: `${config.geoserverUrl}/dgu/wms`,
			params: {'LAYERS': LayerName},
			attributions: '   <a class="copyright" href="https://dgu.gov.hr/" target="_blank">Državna geodetska uprava</a>',
			attributionsCollapsible: false
		})
	});
	return myWMSLayer;
}
/* dok se geo ne slozi	
var DOF5_2011 = createCascadedDguWmsLayer('DOF5_2011','dgu:DOF5_2011', false);
var DOF5_2011_FILL_2019_2020 = createCascadedDguWmsLayer('DOF5_2011','dgu:DOF5_2011', true);
DOF5_2011_FILL_2019_2020.setOpacity(0.6);
var DOF5_2019_2020 = createCascadedDguWmsLayer('DOF5_2019_2020','dgu:DOF5_2019_2020', true);
*/
/*----- DOF -----*/


export function getWmtsGwcLayer(Name, LayerName, visible, FilterByTennant){
	const myWmsGwcLayer = new TileLayer({
		name: Name,
		visible: visible,
		source: new WMTS({
			url: `${config.geoserverUrl}/gwc/service/wmts` + (FilterByTennant ? `?CQL_FILTER=code='${config.tenant}'` : ''),
			layer: LayerName,
			matrixSet: "EPSG:3765",
			format: "image/png",
			projection: htrs,
			tileGrid: htrs_tilegrid
		})
	});
	return myWmsGwcLayer;
}

export function createHeatMap(sourceLayerName, layerName, weightFunction, gradientColors){
	const myHeatMapLayer = new HeatmapLayer({
		name: layerName,
		source: new VectorSource({
			url: `${config.geoserverUrl}/ows?service=WFS&version=1.0.0&request=GetFeature&`+
				`typename=${sourceLayerName}&outputFormat=application/json`,
			format: new OlFormatGeoJSON()
		}),
		gradient:gradientColors,
		blur: 25,
		radius: 20,
		weight: weightFunction,
		zIndex: 30
	  });
	return myHeatMapLayer;
}
export function setHeatMap(heatMapLayer, zoom){
	//console.log(zoom);
	heatMapLayer.setBlur(parseInt(zoom, 10)*4);
	heatMapLayer.setRadius(parseInt(zoom, 10)*4);
}

export function createClusterTrendlayer(sourceLayerName, layerName){	
	function styleFunction(feature, resolution) {
		
		const {ponuda, potraznja} = feature.get('features').reduce((sums, cur) => {
			sums.ponuda += cur.get('capacity');
			sums.potraznja += cur.get('demand');
			return sums;
		},{ponuda:0, potraznja:0});
		
		const color = (ponuda>potraznja) ? [0,255,0] : (potraznja>ponuda) ? [255,0,0]: [255,255,0];
		
		return new Style({
			renderer(coordinates, state) {
				const [x, y] = coordinates;
				const ctx = state.context;
				const radius = 40;
				const gradient = ctx.createRadialGradient(x, y, 0, x, y, radius);
				gradient.addColorStop(0, `rgba(${color[0]},${color[1]},${color[2]},1)`);
				gradient.addColorStop(0.8, `rgba(${color[0]},${color[1]},${color[2]},0.3)`);
				gradient.addColorStop(1, `rgba(${color[0]},${color[1]},${color[2]},0)`);
				ctx.beginPath();
				ctx.arc(x, y, radius, 0, 2 * Math.PI, true);
				ctx.fillStyle = gradient;
				ctx.fill();

				//ctx.arc(x, y, radius, 0, 2 * Math.PI, true);
				//ctx.strokeStyle = 'rgba(255,0,0,1)';
				//ctx.stroke();
			}
		});
    }
	
	var clusterlayer = new VectorLayer({
		name: layerName,
		//maxZoom: 12,
		//minResolution:switchResolution,
		source: new Cluster({ 
			distance: 40,
			source: new VectorSource({
				url: `${config.geoserverUrl}/ows?service=WFS&version=1.0.0&request=GetFeature&`+
					`typename=${sourceLayerName}&outputFormat=application/json`,
				format: new OlFormatGeoJSON()
			})
		}),
		style: styleFunction,
		zIndex: 30
	});
    
	return clusterlayer;
}